export default __webpack_public_path__ + "static/33-897b53b48cf14e666f2db3d952ee2f19.png";